import { ServiceMaker, methods, services } from "@/services";

export const customerOpenServiceTicket = (payload) =>
  ServiceMaker(
    `/servicerequest/ticket/list?assignTo=${payload.id}`,
    methods.GET,
    services.master,
    payload
  );

export const updateCustomerServiceTicket = (payload) =>
  ServiceMaker(
    `/servicerequest/ticket/update/${payload.id}`,
    methods.PUT,
    services.master,
    payload.data
  );

export const postCommentCustomerServiceTicket = (payload) =>
  ServiceMaker(
    `/servicerequest/ticket/postcomment/${payload.id}`,
    methods.POST,
    services.master,
    payload.data
  );
